// @ts-ignore: mixpanel-browser has no types
import mixpanel from 'mixpanel-browser'
import config from '@/core/config'

const token = config.mixpanel.projectToken

if (token) {
  mixpanel.init(token, {
    debug: !config.app.isProd,
    // Do not track or write any mp_* storage until the user grants
    // Analytics consent via Termly. Prevents pre-consent cookie leak.
    opt_out_tracking_by_default: true,
    opt_out_persistence_by_default: true
  })

  // Apply Termly's current Analytics consent to Mixpanel.
  const applyMixpanelConsent = () => {
    const state = (window as any).Termly?.getConsentState?.()
    if (state?.analytics) {
      // opt_in re-enables persistence + flushes any queued events
      mixpanel.opt_in_tracking()
    } else {
      // opt_out disables tracking and clears mp_* cookies/storage
      mixpanel.opt_out_tracking()
    }
  }

  // Register with Termly's Event API once the CMP is available.
  const registerTermlyConsent = () => {
    const Termly = (window as any).Termly
    if (!Termly?.on) return
    Termly.on('initialized', applyMixpanelConsent)
    Termly.on('consent', applyMixpanelConsent)
    applyMixpanelConsent()
  }

  // Case A: Termly loads after this bundle → its script onload calls this.
  ;(window as any).onTermlyLoaded = registerTermlyConsent
  // Case B: Termly already finished loading before this bundle ran.
  if ((window as any).Termly?.on) {
    registerTermlyConsent()
  }
} else {
  // Replace all mixpanel methods with no-ops if token is missing
  const noop = () => {}
  const methods = [
    'init',
    'track',
    'identify',
    'people',
    'reset',
    'register',
    'unregister',
    'get_distinct_id',
    'alias',
    'opt_in_tracking',
    'opt_out_tracking',
    'has_opted_in_tracking',
    'has_opted_out_tracking',
    'clear_opt_in_out_tracking',
    'time_event',
    'register_once',
    'set_config',
    'get_config',
    'get_property',
    'disable',
    'off',
    'on',
    'once',
    'track_links',
    'track_forms',
    'track_pageview',
    'track_links',
    'track_forms',
    'register',
    'unregister',
    'get_distinct_id',
    'alias',
    'opt_in_tracking',
    'opt_out_tracking',
    'has_opted_in_tracking',
    'has_opted_out_tracking',
    'clear_opt_in_out_tracking',
    'time_event',
    'register_once',
    'set_config',
    'get_config',
    'get_property',
    'disable',
    'off',
    'on',
    'once',
    'track_links',
    'track_forms',
    'track_pageview'
  ]
  methods.forEach((method) => {
    // @ts-ignore
    mixpanel[method] = noop
  })
  // people is an object with methods - create it if it doesn't exist
  if (!mixpanel.people) {
    // @ts-ignore
    mixpanel.people = {}
  }
  
  // Add common people methods
  const peopleMethods = ['set', 'set_once', 'unset', 'increment', 'append', 'union', 'track_charge', 'clear_charges', 'delete_user']
  peopleMethods.forEach((method) => {
    // @ts-ignore
    mixpanel.people[method] = noop
  })
}

export default mixpanel
